import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'
import routes from './routes'
import i18n from '../plugins/i18n'
import http from '../plugins/http'

Vue.use(Router)

const checkRequiredSubscription = function (subscription) {
  if (!subscription) {
    return true
  }

  let checked = false
  if (store.state.user) {
    if (store.state.user.isProfessional && subscription === 'pro') {
      checked = true
    } else if (store.state.user.isBusiness && subscription === 'business') {
      checked = true
    }
  }
  return checked
}

const setDocumentTitle = function (to) {
  const vendorTitle = process.env.VENDOR === 'mtf' ? 'DVM Cloud Service' : 'VBus.net'
  if (to.meta.breadcrumb) {
    document.title = i18n.t(to.meta.breadcrumb[to.meta.breadcrumb.length - 1].key) + ' · ' + vendorTitle
    store.commit('setPage', {})
    store.commit('setBreadcrumb', to.meta.breadcrumb)
  } else if (to.meta.page) {
    if (to.meta.page.key) {
      document.title = i18n.t(to.meta.page.key) + ' · ' + vendorTitle
    } else {
      document.title = vendorTitle
    }
    store.commit('setPage', to.meta.page)
    store.commit('setBreadcrumb', null)
  } else {
    document.title = '!KEIN TITEL!'
    store.commit('setPage', {
      title: null,
      key: null,
      icon: null
    })
  }
}

const router = new Router({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition && savedPosition.x && savedPosition.y) {
      return { x: savedPosition.x, y: savedPosition.y }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  let authorized = store.state.auth ? store.state.auth.authorized : null

  if (to.query && to.query.lng) {
    let lng = 'de'
    const languages = ['de', 'en', 'fr', 'es', 'it']
    if (languages.indexOf(to.query.lng) !== -1) {
      lng = to.query.lng
    }
    store.commit('setLng', lng)
    i18n.i18next.changeLanguage(lng)
  }

  let isPublic = false
  if (to.meta.isPublic) {
    isPublic = true
  } else if (to.meta.page && to.meta.page.isPublic) {
    isPublic = true
  } else if (to.meta.breadcrumb && to.meta.breadcrumb.isPublic) {
    isPublic = true
  }
  let requires = null
  if (to.meta.page) {
    if (to.meta.page.requires) {
      requires = to.meta.page.requires
    }
  }

  const hasRequiredSubscription = checkRequiredSubscription(requires)
  let acceptedEula = false
  if (store.state.user) {
    acceptedEula = store.state.user.eula_version === store.state.user.current_eula
  }

  const ignoreRoutes = ['OwnershipClaim', 'My-Profile', 'Settings', 'DiscoveryTool', 'DataViewer', 'SettingsDocumentationGenerator', 'ChangeEmail', 'ChangePassword', 'Feedback']

  if (authorized && (to.path === '/register' || to.path === '/resend-registration-email')) {
    setDocumentTitle(to)
    next('/profil')
  } else if (!hasRequiredSubscription) {
    setDocumentTitle(to)
    next('/Information')
  } else if (!authorized && !isPublic) {
    http.readSession().then(isAuthorized => {
      if (isAuthorized) {
        setDocumentTitle(to)
        next()
      } else {
        store.commit('setAuthorization', false)
        store.commit('setUser', null)
        next('/Login')
      }
    })
  } else if (to.path !== '/accept-eula') {
    if (!acceptedEula && !isPublic && to.path !== '/profil') {
      next('/accept-eula')
    } else if (!isPublic && ignoreRoutes.indexOf(to.name) === -1 && store.state.user.valid_ownership_count < 1) {
      if (to.meta) {
        store.commit('setMeta', to.meta)
      }
      setDocumentTitle(to)
      // allow mtf-admin access without valid_ownership_count
      if (store.state.user.role === 25) {
        next()
      } else {
        next('/ownership/claim')
      }
    } else {
      if (to.meta) {
        store.commit('setMeta', to.meta)
      }
      setDocumentTitle(to)
      next()
    }
  } else {
    if (to.meta) {
      store.commit('setMeta', to.meta)
    }
    setDocumentTitle(to)
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js